import { FORTA_BLUE } from '../../../utils/colors';

export const MODIFIER_ROW_ICON_BUTTON_SX = {
  width: 48,
  height: 30,
  border: `2px solid ${FORTA_BLUE.primary}`,
  borderRadius: '20px',
  backgroundColor: 'transparent',
  '&:hover': { backgroundColor: 'transparent' },
};

// FHInputField bakes minWidth: 150 onto its StyledInputField root; override it so the
// 2-char modifier inputs fit their narrow columns and stay aligned under the headers.
export const MODIFIER_INPUT_SX = {
  width: '100%',
  minWidth: 0,
  boxShadow: 'none',
  '& .MuiTextField-root': { minWidth: 0 },
};

// This row is wide (5 dropdowns + 4 inputs + actions). Rather than crush ten fields into a
// 12-col grid, each row and the section header lay out as a fixed-width flex track and share
// this single scroll container in the section so they scroll together and stay column-aligned.
export const MODIFIER_ROW_SCROLL_SX = {
  width: '100%',
  overflowX: 'auto',
};

export const MODIFIER_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  minWidth: 'fit-content',
  px: 1,
  py: 1,
};

// Column widths shared between the row cells and the section header cells. minWidth: 0 lets
// each field's input shrink into its track instead of overflowing (a prior payor-row bug).
export const SERVICE_CODE_CELL_SX = { flex: '0 0 220px', minWidth: 0 };
export const PAYOR_CELL_SX = { flex: '0 0 200px', minWidth: 0 };
export const LOCATION_CELL_SX = { flex: '0 0 150px', minWidth: 0 };
export const DELIVERY_METHOD_CELL_SX = { flex: '0 0 170px', minWidth: 0 };
export const MODIFIER_CELL_SX = { flex: '0 0 90px', minWidth: 0 };
export const ACTIONS_CELL_SX = {
  flex: '0 0 180px',
  display: 'flex',
  gap: 1,
  alignItems: 'center',
  minWidth: 0,
};
